import Vue from 'vue';
import moment from 'moment';

const filters = () => {
  Vue.filter('capitalize', function (value) {
    if (value && typeof value === 'string') {
      return value.charAt(0)
        .toUpperCase() + value.slice(1);
    }
    return '';
  });

  Vue.filter('formatDate', function (value, formatType = 'LL') {
    if (!value) return '';
    return moment(value)
      .format(formatType);
  });

  Vue.filter('truncate', (value, length, clamp) => {
    if (value && typeof value === 'string') {
      // eslint-disable-next-line no-param-reassign
      clamp = clamp || '...'
      return value.length > length ? value.slice(0, length) +
        clamp : value
    }

    return ''
  })
};

export default filters;
